import React, {useState} from 'react';
import {Button, Form, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Spinner} from "reactstrap";
import {addDoc, collection} from "firebase/firestore";
import {getDb} from "../../util/Constants";

function AddDifficulty(props) {
    const [difficulty, setDifficulty] = useState("");
    const [passingScore, setPassingScore] = useState("");
    const [load, setLoad] = useState(false)

    const handleSubmit = async (e) => {

        e.preventDefault()
        setLoad(true);
        let dataCapital=difficulty.charAt(0).toUpperCase() + difficulty.slice(1)
        const payload = {
            difficulty:dataCapital ,
            passingScore: Number(passingScore)
        }
        const docRef = await addDoc(collection(getDb(), "levelDifficultyScores"), payload)
        props.getDifficulties();
        // props.setRegions((current) => [...current, { region: region }])

        setLoad(false)
        props.toggle()
        setDifficulty("")
        setPassingScore("")
    };




    return (
        <div>

            <Modal isOpen={props.modal} toggle={props.toggle}>
                <ModalHeader toggle={props.toggle}>Add Difficulty</ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleSubmit}>
                        <div className="">

                            <FormGroup>
                                <Label for="department">
                                    Difficulty
                                </Label>
                                <Input
                                    type="text"
                                    id="department"
                                    maxLength="250"
                                    value={difficulty}
                                    required
                                    className="form-control-alternative"
                                    onChange={(e) => setDifficulty(e.target.value)}
                                />

                            </FormGroup>
                            <FormGroup>
                                <Label for="department">
                                    Passing Score
                                </Label>
                                <Input
                                    type="number"
                                    value={passingScore}
                                    required
                                    className="form-control-alternative"
                                    onChange={(e) => setPassingScore(e.target.value)}
                                />

                            </FormGroup>
                        </div>
                        <Button color="primary" type={"submit"} disabled={load}>
                            {load ? (
                                <Spinner color="light" size="sm" />
                            ) : (
                                "Save"
                            )}
                        </Button>
                        <Button color="secondary" onClick={props.toggle}>
                            Cancel
                        </Button>
                    </Form>
                </ModalBody>
            </Modal>
        </div>
    );
}

export default AddDifficulty;